/* global fest */
define((require) => {
    'use strict';

    require('../../../static/fest/compiled/landings');

    const toolkit = require('toolkit/b-toolkit/b-toolkit');

    require('toolkit/b-captcha/b-captcha');
    require('toolkit/b-checkbox/b-checkbox');
    require('toolkit/b-controls-group/b-controls-group');
    require('toolkit/b-input/b-input');
    require('toolkit/b-layer/b-layer');
    require('toolkit/b-panel/b-panel');
    require('toolkit/b-select/b-select');
    require('toolkit/b-spinner/b-spinner');
    require('toolkit/b-tabsheet/b-tabsheet');
    require('toolkit/btn/btn');

    toolkit.setup({
        template: 'landings',
    });

    // 💩
    fest[''] = fest.landings;
    fest.undefined = fest.landings;
});
